module.exports = __webpack_public_path__ + "static/media/agile_big.89ba8f0a.png";